<template>
    <div>
        <div class="d-flex">
            <div class="title text-muted mt-auto">{{ title }}</div>
            <div class="ml-auto">
                <div class="input-group input-group-sm mb-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text fas fa-filter fa-sm text-muted"></span>
                    </div>
                    <select class="custom-select custom-select-sm" v-model="filter" @change="refresh()">
                        <option value="all">All</option>
                        <option value="shared">Shared</option> 
                        <option value="unshared">Unshared</option>              
                    </select>
                </div>               
            </div>
        </div>
        <div v-if="loading" class="pt-3 border-top">            
            <h5 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h5>
        </div>        
        <div v-else class="table-responsive">
            <table class="table table-sm">
                <thead>
                    <th>Client</th>
                    <th class="text-right">Total Claims</th>
                    <th class="text-right">Unpaid</th>
                    <th class="text-right">Under Paid</th>
                    <th class="text-right">Paid Late</th>
                </thead>
                <tbody>
                    <tr v-for="client in clients" :key="'penalty-claim-summary-' + client.id">
                        <td>{{ client.name }}</td>
                        <td class="text-right"><a :href="getServiceListUrl(client.id, 'all')">{{ client.total_claim_count }}</a></td>
                        <td class="text-right"><a :href="getServiceListUrl(client.id, 'unpaid')">{{ client.unpaid_claim_count }}</a></td>
                        <td class="text-right"><a :href="getServiceListUrl(client.id, 'underpaid')">{{ client.under_paid_claim_count }}</a></td>
                        <td class="text-right"><a :href="getServiceListUrl(client.id, 'latepaid')">{{ client.late_paid_claim_count }}</a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        href: String
    },    
    data() {
        return {
            clients: [],
            filter: 'all',
            loading: false
        }
    },
    methods: {
        refresh: function () {
            
            this.loading = true;
            axios.post(this.href, { filter: this.filter })
                .then(response => {
                    this.clients = response.data.clients;
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error.response);
                    this.loading = false;
                });
        },
        getServiceListUrl: function (clientId, paymentStatus) {

            let url = new URL(window.location.origin + '/clients/' + clientId + '/services');
            url.searchParams.append('shareStatus', this.filter);
            url.searchParams.append('paymentStatus', paymentStatus);

            return url.href;
        },        
    },
    mounted() {
        this.refresh();
    }    
}
</script>

<style scoped>

</style>